var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.data),function(item,idx){return _c('div',{key:idx,staticClass:"actions-block actions-item actions-item--chunked",class:item.color || 'dark-blue'},[_vm._v(" "+_vm._s(item.text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }